import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import './ComplianceSectionStyles.scss';
const BASE_CLASS = 'ai-chat-compliance';
const TERMS_OF_SERVICE_URL = 'https://www.inspectpoint.com/terms-of-service/';
export function ComplianceSection() {
    return (React.createElement("div", { className: BASE_CLASS },
        React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__text` }, "AI-generated content may contain errors. Always verify important information."),
        React.createElement("div", { className: `${BASE_CLASS}__links` },
            React.createElement(Text, { variant: "link-paragraph", as: "a", href: TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer" }, "Terms of Service"))));
}
